'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _class, _class2, _temp; /* eslint-disable react/sort-comp */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactI18next = require('react-i18next');

var _lodash = require('lodash');

var _chemist = require('chemist');

var _Adjustment = require('../Adjustment');

var _Adjustment2 = _interopRequireDefault(_Adjustment);

var _LineItem = require('../LineItem');

var _LineItem2 = _interopRequireDefault(_LineItem);

var _Total = require('../Adjustment/Total');

var _Total2 = _interopRequireDefault(_Total);

var _ExternalLink = require('../ExternalLink');

var _ExternalLink2 = _interopRequireDefault(_ExternalLink);

var _StoreCreditSummary = require('../StoreCreditSummary');

var _StoreCreditSummary2 = _interopRequireDefault(_StoreCreditSummary);

var _FormInput = require('../FormInput');

var _money = require('../../helpers/money');

var Money = _interopRequireWildcard(_money);

var _order = require('../../helpers/order');

var _localisedPaths = require('../../helpers/localisedPaths');

var _paintersStyle = require('./paintersStyle.scss');

var _paintersStyle2 = _interopRequireDefault(_paintersStyle);

var _Form = require('../Form');

var _Form2 = _interopRequireDefault(_Form);

var _CheckoutContact = require('../../components/CheckoutContact');

var _CheckoutContact2 = _interopRequireDefault(_CheckoutContact);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaintersCartForm = (_dec = (0, _chemist.configurable)(), _dec2 = (0, _reactI18next.translate)(), _dec3 = (0, _reactCssModules2.default)(_paintersStyle2.default, { allowMultiple: true }), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(PaintersCartForm, _React$Component);

  function PaintersCartForm(props) {
    (0, _classCallCheck3.default)(this, PaintersCartForm);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PaintersCartForm.__proto__ || (0, _getPrototypeOf2.default)(PaintersCartForm)).call(this, props));

    _this.state = {
      dryTesterEl: 'button'
    };

    _this.renderDryTesterButton = _this.renderDryTesterButton.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(PaintersCartForm, [{
    key: 'getUserRoles',
    value: function getUserRoles() {
      if (!this.props.user) {
        return [];
      }

      return this.props.user.roles || [];
    }
  }, {
    key: 'getProductList',
    value: function getProductList(products, newSize) {
      return products.map(function (product) {
        var baseArticleNumber = product.variant.sku.split(':')[1].split('_')[0];
        return {
          articleNumber: '' + baseArticleNumber + (newSize === 'A5' ? '_A5' : ''),
          quantity: product.quantity
        };
      });
    }
  }, {
    key: 'renderEstimatedShippingCost',
    value: function renderEstimatedShippingCost(rate) {
      var t = this.props.t;


      if (rate > 0) {
        return _react2.default.createElement(_reactI18next.Interpolate, {
          i18nKey: 'spree.shipping_from_amount',
          amount: Money.format(rate, this.props.order.currency, this.props.config.store)
        });
      }

      return t('spree.free');
    }
  }, {
    key: 'renderPromotion',
    value: function renderPromotion(promotionTotal) {
      var t = this.props.t;

      if (!promotionTotal) {
        return '';
      }

      var amount = Money.format(promotionTotal, this.props.order.currency, this.props.config.store);

      return _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(_Adjustment2.default, {
          title: t('discount'),
          amount: '-' + amount
        })
      );
    }
  }, {
    key: 'findCheapestShippingRate',
    value: function findCheapestShippingRate() {
      var shippingMethods = this.props.order.shippingMethods;
      if (!shippingMethods) return null;

      var lowest = shippingMethods.shippingRates.sort(function (a, b) {
        return parseFloat(a.amount) < parseFloat(b.amount);
      });

      return lowest[0];
    }
  }, {
    key: 'isCustomerServiceRep',
    value: function isCustomerServiceRep() {
      return this.getUserRoles().indexOf('customer_service') !== -1;
    }
  }, {
    key: 'renderCustomerServiceElements',
    value: function renderCustomerServiceElements() {
      if (!this.isCustomerServiceRep()) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { styleName: 'customerService-block' },
        this.renderSwitchAllButtons(),
        this.renderDryTesterButton()
      );
    }
  }, {
    key: 'renderSwitchAllButtons',
    value: function renderSwitchAllButtons() {
      var _this2 = this;

      var A5Products = this.props.order.lineItems.filter(function (line) {
        return line.variant.name === 'Colour Chip Tester' && line.variant.size === 'A5';
      });
      var A8Products = this.props.order.lineItems.filter(function (line) {
        return line.variant.name === 'Colour Chip Tester' && line.variant.size === 'A8';
      });

      if (A5Products.length === 0 && A8Products.length === 0) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { styleName: 'chipButton-block' },
        A8Products.length !== 0 && _react2.default.createElement(
          'button',
          {
            onClick: function onClick(e) {
              e.preventDefault();
              _this2.handleSwitchAllChips(A8Products, 'A5');
            },
            styleName: 'chipButton-button'
          },
          'Switch all Chips to A5'
        ),
        A5Products.length !== 0 && _react2.default.createElement(
          'button',
          {
            onClick: function onClick(e) {
              e.preventDefault();
              _this2.handleSwitchAllChips(A5Products, 'A8');
            },
            styleName: 'chipButton-button'
          },
          'Switch all Chips to A8'
        )
      );
    }
  }, {
    key: 'promotionTotal',
    value: function promotionTotal(order) {
      return order.adjustments.reduce(function (total, adjustment) {
        return adjustment.promotionCode ? total + parseFloat(adjustment.amount) * -1 : total;
      }, 0);
    }
  }, {
    key: 'handleSwitchAllChips',
    value: function handleSwitchAllChips(products, newSize) {
      var items = this.getProductList(products, newSize);
      var oldIds = products.map(function (product) {
        return product.id;
      });
      this.props.switchAllChips(items, oldIds);
    }
  }, {
    key: 'debounce',
    value: function debounce(callBack, delay) {
      var timer = void 0;
      return function (event) {
        event.persist();
        clearTimeout(timer);
        timer = setTimeout(function () {
          callBack(event.target.value);
        }, delay);
      };
    }
  }, {
    key: 'getFilteredDryTesters',
    value: function getFilteredDryTesters(value) {
      this.props.requestFilteredProducts(value);
    }
  }, {
    key: 'handleAddDryTester',
    value: function handleAddDryTester(event) {
      event.persist();
      var product = JSON.parse(event.target.getAttribute('data-product'));
      this.props.addDryTester(product.articleNumber);
    }
  }, {
    key: 'renderDryTesterButton',
    value: function renderDryTesterButton() {
      var _this3 = this;

      return _react2.default.createElement(
        'div',
        { styleName: 'quickOrder-block' },
        this.state.dryTesterEl === 'button' && _react2.default.createElement(
          'button',
          {
            styleName: 'quickOrder-button',
            onClick: function onClick(e) {
              e.preventDefault();
              _this3.setState({ dryTesterEl: 'input' });
            }
          },
          '+ Add a Dry Tester'
        ),
        this.state.dryTesterEl === 'input' && _react2.default.createElement(
          'div',
          { styleName: 'quickOrder-input_wrapper' },
          _react2.default.createElement(_Icon2.default, { type: 'painters-search' }),
          _react2.default.createElement('input', {
            placeholder: 'Search by article number',
            styleName: 'quickOrder-input',
            type: 'text',
            onChange: this.debounce.call(this, this.getFilteredDryTesters.bind(this), 200),
            autoFocus: true
          })
        ),
        this.state.dryTesterEl === 'input' && _react2.default.createElement(
          'ul',
          { styleName: 'quickOrder-results' },
          Array.isArray(this.props.filteredProducts) && this.props.filteredProducts.length === 0 && _react2.default.createElement(
            'li',
            { styleName: 'quickOrder-results_item' },
            'No products found'
          ),
          Array.isArray(this.props.filteredProducts) && this.props.filteredProducts.map(function (product) {
            var itemStyleName = product.quantity < 1 ? 'quickOrder-results_item quickOrder-out_of_stock_background' : 'quickOrder-results_item';
            return _react2.default.createElement(
              'li',
              { key: product.id, styleName: itemStyleName },
              _react2.default.createElement('span', {
                style: {
                  display: 'inline-block',
                  width: 24,
                  height: 24,
                  backgroundColor: '#' + product.colorHex
                }
              }),
              _react2.default.createElement(
                'span',
                { styleName: 'quickOrder-results_item-name' },
                product.colorName
              ),
              _react2.default.createElement(
                'span',
                null,
                product.colorId
              ),
              product.quantity < 1 ? _react2.default.createElement(
                'span',
                { styleName: 'quickOrder-out_of_stock_text' },
                _react2.default.createElement(
                  'i',
                  null,
                  'Out of Stock'
                )
              ) : _react2.default.createElement(
                'span',
                {
                  styleName: 'quickOrder-results_item-add',
                  'data-in-stock': product.quantity >= 1,
                  'data-product': (0, _stringify2.default)(product),
                  onClick: _this3.handleAddDryTester.bind(_this3)
                },
                '+add'
              )
            );
          })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _context,
          _this4 = this;

      var t = this.props.t;

      var promotionTotal = this.promotionTotal(this.props.order);
      var shippingRate = this.findCheapestShippingRate();
      var lng = this.props.params.lng;

      var subTotalWithoutTax = this.props.order.itemTotal - this.props.order.taxTotal;
      var subTotal = shippingRate ? subTotalWithoutTax + shippingRate.amount : subTotalWithoutTax;

      var formActionsClass = this.isCustomerServiceRep() ? 'quickOrderFormSpacing' : 'formActions';

      return _react2.default.createElement(
        _Form2.default,
        {
          action: (0, _localisedPaths.localisedAction)(this.props.config.store, 'cart', lng),
          onSubmit: (_context = this.props).onSubmit.bind(_context),
          method: 'post',
          className: 'row'
        },
        _react2.default.createElement(
          'div',
          { styleName: 'm-orderForm', className: 'col-md-12' },
          _react2.default.createElement(
            'div',
            { styleName: 'm-orderForm__headings', className: 'clearfix' },
            _react2.default.createElement(
              'div',
              { styleName: 'a-orderForm__heading a-orderForm__heading--description' },
              t('spree.description')
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'a-orderForm__heading a-orderForm__heading--size' },
              t('spree.size')
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'a-orderForm__heading a-orderForm__heading--quantity' },
              t('spree.quantity')
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'a-orderForm__heading a-orderForm__heading--item-price' },
              t('spree.item_price')
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'a-orderForm__heading a-orderForm__heading--price' },
              t('spree.price')
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'm-orderForm__lineItems', className: 'clearfix' },
            this.props.order.lineItems.map(function (lineItem, index) {
              var _context2;

              return _react2.default.createElement(_LineItem2.default, (0, _extends3.default)({}, lineItem, {
                index: index,
                key: lineItem.id,
                inputType: _this4.props.cart[lineItem.id.toString()],
                onChangeQuantity: (_context2 = _this4.props).onChange.bind(_context2),
                switchChipSize: (_context2 = _this4.props).switchChipSize.bind(_context2),
                onClickRemove: (_context2 = _this4.props).onRemove.bind(_context2),
                params: _this4.props.params,
                currency: _this4.props.order.currency,
                user: _this4.props.user,
                errorMessage: _this4.props.lineItemErrors && _this4.props.lineItemErrors[lineItem.id]
              }));
            })
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'orderTotals-list' },
            this.renderCustomerServiceElements(),
            _react2.default.createElement(
              'ul',
              { styleName: 'orderTotals' },
              _react2.default.createElement(
                'li',
                { styleName: 'orderSubtotal' },
                _react2.default.createElement(_Adjustment2.default, {
                  title: t('spree.subtotal'),
                  amount: '' + Money.format(this.props.order.itemTotal - this.props.order.taxTotal, this.props.order.currency, this.props.config.store),
                  extraStyleName: 'm-orderSubtotal'
                })
              ),
              this.renderPromotion(promotionTotal),
              (0, _order.automaticPromotions)(this.props.order.adjustments).map(function (adjustment) {
                return _react2.default.createElement(
                  'li',
                  { key: (0, _lodash.uniqueId)() },
                  _react2.default.createElement(_Adjustment2.default, {
                    title: adjustment.label,
                    amount: '-' + Money.format(Math.abs(adjustment.amount), _this4.props.order.currency, _this4.props.config.store)
                  })
                );
              }),
              shippingRate && _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(_Adjustment2.default, {
                  title: t('spree.estimated_delivery_cost'),
                  information: shippingRate.description,
                  amount: this.renderEstimatedShippingCost(shippingRate.amount)
                })
              ),
              _react2.default.createElement(
                'li',
                { styleName: 'orderTotal' },
                _react2.default.createElement(_Total2.default, {
                  title: t('spree.total'),
                  information: t('spree.excluding_tax'),
                  amount: Money.format(subTotal, this.props.order.currency, this.props.config.store)
                })
              ),
              _react2.default.createElement(
                'li',
                { styleName: 'totalPlusVat' },
                _react2.default.createElement(_Adjustment2.default, {
                  title: t('spree.tax'),
                  amount: this.props.order.displayTaxTotal,
                  extraStyleName: 'm-subtotals__information'
                })
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(_Adjustment2.default, {
                  title: t('spree.total'),
                  information: t('spree.tax_included'),
                  amount: this.props.order.displayTotal,
                  extraStyleName: 'm-subtotals__information'
                })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: formActionsClass },
            _react2.default.createElement(
              _StoreCreditSummary2.default,
              { user: this.props.user },
              _react2.default.createElement(_ExternalLink2.default, {
                href: (0, _localisedPaths.localisedPath)(this.props.config.store, 'coloursPath', lng),
                text: t('spree.continue_shopping')
              })
            ),
            this.props.config.store.displayCheckoutContactInfo && _react2.default.createElement(_CheckoutContact2.default, null),
            _react2.default.createElement(
              _FormInput.Button,
              null,
              t('spree.proceed_to_checkout')
            )
          )
        )
      );
    }
  }]);
  return PaintersCartForm;
}(_react2.default.Component), _class2.propTypes = {
  order: _react.PropTypes.object.isRequired,
  user: _react.PropTypes.object.isRequired
}, _class2.defaultProps = {
  amount: false
}, _temp)) || _class) || _class) || _class);
exports.default = PaintersCartForm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/CartForm/painters.js
// module id = 2270
// module chunks = 0